import { t } from '../../../../locale';
import { FlowInterface } from '../flow-interface';
import { generateBuyLink } from '../../helper/utils';
import { planTypes } from '../../constant';

export default class Trial2paid extends FlowInterface {
  getCurrentParams() {
    return {
      type: this.flowType,
      subPlan: planTypes.EVENT_SAAS_CORE,
      oldPlanCode: this.productEntryData?.oldPlanCode,
      campaign_code: this.campaignCode,
      trial_code: this.trialCode,
    }
  }

  getLink() {
    return generateBuyLink(this.getCurrentParams());
  }

  getOptions() {
    return {
      disabled: !this.productEntryData?.currentUserHasPermission,
      buttonTitle: t('billing.product.entry_free_trial.upgrade'),
    };
  }
}
